
/*jshint esversion: 6 */
import React, { Component } from 'react';
import FrontButton from '../buttons/FrontButton.jsx';
import "../styles/Main.css";
import '../res/style.css';

export default class Head extends Component {

    constructor(props)
    {
        super(props);
        this.state={
            banner1Text:"Software Developer",
            banner2Text:"Coding Enthusiast",
            bannerContent:["Coding Enthusiast","Software Developer","Continous Learner"],
            bannerCount:0
            };
    }
 

    componentDidMount(){
        setInterval(()=>{
            if (this.state.bannerCount===(this.state.bannerContent.length-1))
            {
                this.setState({
                    banner1Text:this.state.bannerContent[this.state.bannerCount],
                    banner2Text:this.state.bannerContent[0],
                    bannerCount:0
                });
            }
            else
            {
                this.setState({
                    banner1Text:this.state.bannerContent[this.state.bannerCount],
                    banner2Text:this.state.bannerContent[this.state.bannerCount+1],
                    bannerCount:this.state.bannerCount+1
                });
            }
        },5000);
    }

    render() {
        return (
            /*jshint ignore:start*/
            <div className = "head">
                <div className = "headBanner">
                    <div id ="headShape">  
                    </div>
                    <span id = 'headTitle'>
                        <h2>Hi, I'm Bred!</h2>
                        <h3>{this.state.banner1Text}</h3>
                        <h3>{this.state.banner2Text}</h3>
                    </span>
                </div>
                <span className="menuWrapper">
                    <FrontButton setProjectVis = {this.props.setProjectVis} setAboutVis = {this.props.setAboutVis} setCreditsVis = {this.props.setCreditsVis}
                                 section = 'projects'
                                 href = "#" 
                                 text = "Projects" />
                    <FrontButton setProjectVis = {this.props.setProjectVis} setAboutVis = {this.props.setAboutVis} setCreditsVis = {this.props.setCreditsVis}
                                 section = 'about'
                                 href = "#"
                                 text = "About me" />
                    <FrontButton setProjectVis = {this.props.setProjectVis} setAboutVis = {this.props.setAboutVis} setCreditsVis = {this.props.setCreditsVis}
                                 section = 'credits'
                                 href = "#"
                                 text = "Credits" />
                </span>


            </div>
            /*jshint ignore:end*/
        );
    }
}
